<template>
  <product-list :id="listId" cloud-env="mapping" :getParams="getParams" />
</template>

<script>
import ProductList from '../components/List'

export default {
  name: 'BillProductMapping',
  components: {
    ProductList,
  },
  props: {
    data: Object,
  },
  data () {
    return {
      listId: 'BillProductList',
      getParams: {
        product_type: this.data.product_type,
      },
    }
  },
}
</script>
